import { Fragment, useEffect, useState } from 'react';

import _ from 'lodash';

import moment from 'moment';

import PropTypes from 'prop-types';

import { FadeInAnimation } from '../../shared';

const RoomTypeReviews = (props) => {
    const { selectedRoomType, roomContentCMS } = props;
    const [hasReviews, setHasReview] = useState(false);
    const buildingReviews = _.get(roomContentCMS, 'acf.review');
    const buildingId = _.get(selectedRoomType, 'buildingId');
    const buildingName = _.get(selectedRoomType, 'buildingName');

    useEffect(() => {
        _.forEach(buildingReviews, (review) => {
            const buildingIdFromCMS = _.get(review, 'building_id');
            if (_.lowerCase(buildingId) === _.lowerCase(buildingIdFromCMS)) {
                setHasReview(true);
            }
        });
    }, []);

    const renderReviews = () => {
        return _.map(buildingReviews, (review, index) => {
            const buildingIdFromCMS = _.get(review, 'building_id');
            const title = _.get(review, 'title');
            const description = _.get(review, 'description');
            const person = _.get(review, 'person');
            const date = _.get(review, 'date_of_review');
            let formattedDate = moment() - moment(date);
            formattedDate = moment(formattedDate).format('M');
            const stars = _.get(review, 'star_count');

            if (_.lowerCase(buildingId) === _.lowerCase(buildingIdFromCMS)) {
                return (
                    <Fragment key={index}>
                        <FadeInAnimation>
                            <div>
                                {renderStars(stars)}
                                <h4 className='room-type-reviews-title'>&apos;{title}&apos;</h4>
                                <p className='room-type-reviews-paragraph'>{description}</p>
                                <p className='room-type-reviews-person'>
                                    {person} - {formattedDate} months ago
                                </p>
                            </div>
                        </FadeInAnimation>
                    </Fragment>
                );
            }
            return null;
        });
    };

    const renderStars = (starCount) => {
        const maxStars = 5;
        const starDifference = maxStars - starCount;
        const stars = [];
        for (let i = 0; i < starCount; i += 1) {
            stars.push(<img style={{ marginRight: 4 }} key={i} src="/assets/images/full_star.png" alt="yellow-start" />);
        }
        if (starDifference > 0) {
            for (let i = 0; i < starDifference; i += 1) {
                stars.push(
                    <img style={{ marginRight: 4 }}
                        key={maxStars - starDifference + i}
                        src="/assets/images/empty_star.png"
                        alt="grey-start"
                    />,
                );
            }
        }

        return stars;
    };

    return (
        <div id="review-section">
            {hasReviews && (
                <>
                    <h3 style={{ marginTop: 80, marginBottom: 35 }}>Reviews of {buildingName}</h3>
                    {renderReviews()}
                </>
            )}
        </div>
    );
};

export default RoomTypeReviews;

RoomTypeReviews.propTypes = {
    selectedRoomType: PropTypes.object,
    roomContentCMS: PropTypes.object,
};
